import { Component } from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import { gsap, TweenMax, Expo, Quart } from 'gsap'

@Component({
  selector: 'app-round-arrow-left',
  imports: [
    MatIconModule
  ],
  templateUrl: './round-arrow-left.component.html',
  styleUrl: './round-arrow-left.component.scss'
})
export class RoundArrowLeftComponent {
    onArrowOver(e: any, dir: number) {
        gsap.to(e.target, .5, { borderColor: '#084069', ease: Expo.easeOut });
        gsap.to(e.target.getElementsByClassName('arrowImg'), .25, {
            x: dir == 1 ? '50%' : '-50%', autoAlpha: 0, ease: Expo.easeOut,
            onComplete: () => {
                gsap.fromTo(e.target.getElementsByClassName('arrowImg'), .5, { x: dir != 1 ? '50%' : '-50%' }, { autoAlpha: 1, x: '0%', ease: Expo.easeOut, delay: 0 });
            }
        });


    }

    onArrowOut(e: any, dir: number) {
        gsap.to(e.target, .5, { borderColor: '#000', ease: Expo.easeOut });
    }
}
